export const IP_ADDRESS_DATAS = 'IpAddressDatas/success';
export const LOADING_IP_ADDRESS_DATAS = 'IpAddressDatas/loading';
export const USER_TRACKING_DATAS = 'UserTrackingDatas/success';
export const LOADING_USER_TRACKING_DATAS = 'UserTrackingDatas/loading';